import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reset-email',
  templateUrl: './reset-email.component.html',
  styleUrls: ['./reset-email.component.scss']
})
export class ResetEmailComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
